import './CheckEmail.scss';

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const CheckEmail: FC = () => {
  const { t } = useTranslation();
  return (
    <div className="check-email-info" dangerouslySetInnerHTML={{ __html: t('check_email.info') }} />
  );
};

export default CheckEmail;
